import messages from '../../../locale/messages';

const FCM_TITLE_LIMIT = 65;
const FCM_BODY_LIMIT = 240;

const validate = (values) => {
  const errors = {};

  if (!values.title || values.title.trim() === '') {
    errors.title = messages.required;
  } else if (values.title.length > FCM_TITLE_LIMIT) {
    errors.title = messages.titleLength;
  }

  if (!values.message || values.message.trim() === '') {
    errors.message = messages.messageRequired;
  } else if (values.message.length > FCM_BODY_LIMIT) {
    errors.message = messages.messageLength;
  }

  if (values.sendMode === 'later') {
    if (!values.scheduledAt) {
      errors.scheduledAt = messages.required;
    } else {
      const scheduled = new Date(values.scheduledAt);
      if (isNaN(scheduled.getTime())) {
        errors.scheduledAt = messages.invalidDate;
      } else if (scheduled <= new Date()) {
        errors.scheduledAt = messages.scheduledAtFuture;
      }
    }
  }

  return errors;
};

export default validate;
